import React from 'react';
import { Segmented } from 'antd';
import type { SortingDashboardBusinessTypeTab } from '../sortingDashboardOrderFlowConstants';

export type SortingOrderFlowSegmentedProps = {
    value: SortingDashboardBusinessTypeTab;
    onChange: (v: SortingDashboardBusinessTypeTab) => void;
    /** 与仓库类型同一行右侧区域（如「下载」按钮） */
    extra?: React.ReactNode;
};

/**
 * 与规模看板「订单类型」一致的紫色 Segmented（尾程仓 / 分拣仓）
 */
export const SortingOrderFlowSegmented: React.FC<SortingOrderFlowSegmentedProps> = ({ value, onChange, extra }) => {
    return (
        <>
            <style>{`
                .sorting-order-flow-segmented.ant-segmented .ant-segmented-item {
                    font-weight: 600;
                    min-height: 40px;
                    line-height: 38px;
                    padding-inline: 18px;
                }
                .sorting-order-flow-segmented.ant-segmented .ant-segmented-item-selected {
                    background: #7c3aed !important;
                    color: #fff !important;
                    box-shadow: none !important;
                }
                .sorting-order-flow-segmented.ant-segmented .ant-segmented-item-selected .ant-segmented-item-label {
                    color: #fff !important;
                }
                .sorting-order-flow-segmented.ant-segmented .ant-segmented-thumb {
                    background: #7c3aed !important;
                    box-shadow: 0 1px 3px rgba(124, 58, 237, 0.45);
                }
            `}</style>
            <div className="flex flex-wrap items-center justify-between gap-2 mb-3">
                <div className="flex flex-wrap items-center gap-2">
                    <span className="font-semibold text-gray-800 whitespace-nowrap">仓库类型</span>
                    <Segmented
                        size="large"
                        className="sorting-order-flow-segmented"
                        value={value}
                        onChange={(v) => onChange(v as SortingDashboardBusinessTypeTab)}
                        options={[
                            { label: '尾程仓', value: 'lastMileHub' },
                            { label: '分拣仓', value: 'sortingHub' },
                        ]}
                    />
                </div>
                {extra != null ? <div className="flex-shrink-0">{extra}</div> : null}
            </div>
        </>
    );
};
